export default __webpack_public_path__ + "static/extension-7f8ca129da25b0b7eeca801e47fb185b.png";